import { render, staticRenderFns } from "./TasklistPageHeader.vue?vue&type=template&id=05fb7c98"
import script from "./TasklistPageHeader.vue?vue&type=script&lang=js"
export * from "./TasklistPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports